/**
 * Invoice Workflow Machine Config
 *
 * Spec: Documentation/Specification/04_Processes/application-agnostic/ledger/Invoicing.md
 * States: draft → issued → paid/overdue/cancelled/credited
 */
export const invoiceConfig = {
    id: 'invoice',
    initial: 'draft',
    states: {
        draft: {
            on: {
                ISSUE: { target: 'issued', guard: 'invoiceBalanced' },
                CANCEL: 'cancelled',
            },
        },
        issued: {
            entry: { type: 'issueInvoice' },
            on: {
                PAY: { target: 'paid', guard: 'paymentReceived' },
                MARK_OVERDUE: 'overdue',
                CANCEL: 'cancelled',
                CREDIT: 'credited',
            },
        },
        paid: {
            type: 'final',
        },
        overdue: {
            entry: { type: 'markOverdue' },
            on: {
                PAY: { target: 'paid', guard: 'paymentReceived' },
                CANCEL: 'cancelled',
            },
        },
        cancelled: {
            entry: { type: 'cancelInvoice' },
            type: 'final',
        },
        credited: {
            type: 'final',
        },
    },
};
//# sourceMappingURL=invoice.js.map